import { ShipperGuideClient } from 'core/infra/http/ShipperGuideClient'

import { type DistanceUnit } from '../domain/DistanceUnit'
import { type LanePreference } from '../domain/LanePreferences'
import { ProposalRepository } from '../infra/ProposalRepository'

export type CreateLaneProposalFactoryDependencies = {
  repository: ProposalRepository
}

export type CreateLaneProposalParams = {
  createParams: {
    capacity: number
    flatRate: number
    perDistanceRate: number
    rfpId: string
    laneId: number
    distanceUnit: DistanceUnit
    preference?: LanePreference
  }
  config: { signal: AbortSignal }
}

export function createLaneProposalFactory({ repository }: CreateLaneProposalFactoryDependencies) {
  return function createLane({ createParams, config }: CreateLaneProposalParams) {
    return repository.createLaneProposal(createParams, config)
  }
}

export function createLaneProposal(params: CreateLaneProposalParams) {
  const httpClient = new ShipperGuideClient()
  const repository = new ProposalRepository({ httpClient })
  const createLane = createLaneProposalFactory({ repository })
  return createLane(params)
}
